import type { PayMetrics } from "./types";

function yesterday(): string {
    const d = new Date();
    d.setDate(d.getDate() - 1);
    d.setHours(11, 30, 0, 0);
    return d.toISOString();
}

export function getMockPayMetrics(): PayMetrics {
    const ts = yesterday();
    return {
        createdOn: ts,
        modifiedOn: ts,
        totals: {
            serve: { "Expert 5Star": { calc: 4.6, payout: 475 }, CRT: { calc: 1350, payout: 0 } }, // Expert 5Star 0–5; CRT in seconds
            solve: {
                "Transfer Rate": { calc: 0.04, payout: 0 }, // decimal fraction (0.04 = 4%)
                OCR: { calc: 0.84, payout: 0 }, // decimal fraction (0.84 = 84%)
            },
            sell: { "Net Enrolls": { calc: 2, payout: 150 } }, // net count
        },
        clients: {},
    };
}
